import Scrollbar from 'smooth-scrollbar';

import BezierEasing from 'bezier-easing';

import gsap from 'gsap';

import Component from '../base/component';
import Slider from '../components/slider';
import { byId, qs, qsa } from '../base/dom-utils';
import { sortByData } from '../base/utils';
import Common from '../base/common';


const pageFramesIn = BezierEasing(0.31, 0.19, 0.16, 1);

class About extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.frames = qsa(this.options.frames, this.$el);
        this.$els.mainFrame = qs(this.options.mainFrame, this.$el);

        this.$els.timeline = qs(this.options.timeline, this.$el);
        this.$els.timelineStart = qs(this.options.timelineStart, this.$els.timeline);
        this.$els.events = qsa(this.options.events, this.$el);

        this.$els.scrollIco = byId(this.options.scrollIco);

        const timelineApp = byId('timeline-app');

        this.$els.images = qsa(this.options.eventImg, timelineApp);

        this.setRef('slider', Slider, '#about-slider');

        this._scrollbar = Scrollbar.init(qs('[data-scrollbar]'));

    }

    beforeInit() {

        gsap.set(this.$els.scrollIco, {
            y: -40,
            opacity: 0
        });

        if (Common.mq('desktop') && !Modernizr.touchevents) {

            this.$els.events.forEach((element) => {

                gsap.set(element, {
                    y: 160
                });

                gsap.set(qs(this.options.eventHead, element), {
                    y: 80,
                    autoAlpha: 0
                });

                gsap.set(qsa('p', element), {
                    y: 80,
                    autoAlpha: 0
                });

                gsap.set(this.$els.images, {
                    y: 80,
                    autoAlpha: 0
                });

            });

            this._scrollbar.addListener(() => {

                this.$els.events.forEach((elem) => {

                    if (this._scrollbar.isVisible(elem)) {

                        const enterTl = new TimelineMax();

                        enterTl.to(elem, 0.6, {
                            y: 0,
                            force3D: false
                        });

                        enterTl.to(qs(this.options.eventHead, elem), 0.4, {
                            y: 0,
                            autoAlpha: 1,
                            force3D: false
                    }, '-=0.35');

                        enterTl.staggerTo(qsa('p', elem), 0.3, {
                            y: 0,
                            autoAlpha: 1,
                            force3D: false
                        }, 0.05, '-=0.25');

                        const eventYear = qs(this.options.eventYear, elem);

                        const eventYearPos = eventYear.getBoundingClientRect();

                        const windowHeight = this._scrollbar.getSize().container.height;

                        if (eventYearPos.top <= windowHeight / 1.5) {
                            this.updatePointer();
                        }

                    }

                });

                this.$els.images.forEach((elem) => {

                    if (this._scrollbar.isVisible(elem)) {

                        gsap.to(elem, 0.5, {
                            y: 0,
                            autoAlpha: 1,
                            force3D: false
                        });
                    }

                });

            });

        }

    }

    updatePointer() {

        const timelineTop = this.$els.timeline.getBoundingClientRect().top;

        const middleWindow = this._scrollbar.getSize().container.height / 2;

        // const timelineWindow = this.$els.timeline.offsetHeight - this._scrollbar.getSize().container.height;

        if (timelineTop < middleWindow) {

            gsap.to(this.$els.timelineStart, 0.45, {
                y: Math.min(this.$els.timeline.offsetHeight - 100, -timelineTop + middleWindow)
            });

        } else {

            gsap.to(this.$els.timelineStart, 0.6, {
                y: 0
            });

        }

    }

    animationIn() {

        const enterTl = new TimelineMax();

        const orderedFrames = sortByData(this.$els.frames);

        enterTl.staggerTo(orderedFrames.map((node) => node.children), 0.8, {
            y: 0,
            ease: new Ease(pageFramesIn)
        }, 0.25);

        if (Common.mq('s-tablet')) {

            enterTl.to(this.$els.mainFrame, 0.85, {
                y: 0,
                ease: new Ease(pageFramesIn)
            }, '-=0.4');

        }

        enterTl.to(this.$els.scrollIco, 0.5, {
            y: 0,
            opacity: 1
        });

    }

    getDefaultOptions() {
        return {
            frames: '.o-text__frame',
            mainFrame: '#main-frame',
            sections: '[data-section]',
            events: '.c-event',
            eventHead: '.c-event__head',
            eventYear: '.c-event__year',
            timeline: '.c-timeline',
            timelineStart: '.c-timeline__start',
            eventImg: '.o-img',
            scrollIco: 'scroll-down'
        };
    }

    destroy() {
        this._scrollbar.destroy();
        return super.destroy();
    }
}

export default About;


/** WEBPACK FOOTER **
 ** ./containers/About.js
 **/